/**
 * Created by Rodrigo Quesada on 16/02/17.
 */
import {Component} from '@angular/core';
import {AccordionScreen} from '../../../shared/step/accordion/accordion-screen.class';
import {LicensingExaminationService} from '../../../../domain/model/licenses-certifications/licensingexamination/licensing-examination.service';
import {LicensingExamination} from '../../../../domain/model/licenses-certifications/licensingexamination/licensing-examination.model';
import {EntryWithSupportingDocument} from '../../../shared/step/accordion/entry.class';
import moment = require('moment');

//region Other Classes
class LicensingExaminationEntry extends EntryWithSupportingDocument<LicensingExamination> {
    constructor(esdm: EntryWithSupportingDocument.InjectedMembers, model: LicensingExamination) {
        super(esdm, model, 'licensingExamination');
    }
}
//endregion

@Component({
    template: require('./licensing-examination-screen.component.html')
})
export class LicensingExaminationScreenComponent extends AccordionScreen<LicensingExaminationEntry, LicensingExamination> {

    constructor(esdm: EntryWithSupportingDocument.InjectedMembers, modelService: LicensingExaminationService) {
        super(LicensingExamination, (m) => new LicensingExaminationEntry(esdm, m), 'certificationType', modelService);
    }

    certificationTypes: Array<string> = ['USMLE', 'National Board-NBOME', 'COMLEX/COMVEX', 'FLEX-SPEX', 'State Exam'];

    timesTakenMask = [/\d/, /\d/, /\d/];

    mostRecentExamDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    completionDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/licensingexamination/licensing-examination-screen.component.ts